const isValidDateObject = (value) => value instanceof Date && !Number.isNaN(value.getTime());

// noinspection JSUnusedGlobalSymbols
export default isValidDateObject;
